import ForgotPassword from "./ForgotPassword.presenter";
export default ForgotPassword;
